<template>
  <div class="middle-box text-center loginscreen">
    <div v-if="isLogin">
      <h3>Welcome to WKCDA CMS!</h3>
      <!-- <form class="m-t" role="form">
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Username" v-model="username" required />
        </div>
        <div class="form-group">
          <input type="password" class="form-control" placeholder="Password" v-model="password" required />
        </div>
        <div class="form-group">
          <div class="has-error" v-show="hasErrorMsg">{{ errorMsg }}</div>
        </div>
        <button class="btn btn-primary block full-width m-b" @click="login">Login</button>

        <a ui-sref="forgetPassword">
          <small>Forgot password?</small>
        </a>
      </form> -->
      <div class="form-group" style="padding-top: 15px" v-if="adLoginUrl">
        <button class="btn btn-primary block full-width m-b" @click="ADlogin">Login with Azure AD</button>
      </div>
      <p class="m-t">
        <small>CP &copy; {{ year }}</small>
      </p>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
export default {
  mixins: [config.globalMixin],
  name: "loginController",
  data() {
    return {
      username: "",
      password: "",
      hasErrorMsg: true,
      errorMsg: "",
      year: "shijian",
      isLogin: false,
    };
  },
  created: function () {
    var date = new Date();
    this.year = date.getFullYear();
  },
  methods: {
    async login(e) {
      e.preventDefault();
      let setLogin = this.setFormData({
        userName: this.username,
        password: this.password,
        lang: "en_US",
      });
      try {
        let data = await this.$store.dispatch("login", setLogin);
        if (data) {
          this.$router.push({ path: "/main/homePage" });
        }
      } catch (err) {
        this.$store.commit("setwarning", {
          string: "Network Error.",
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    ADlogin() {
      window.location.href = this.adLoginUrl;
    },
    async getLoginUser() {
      let objdata = {
        userId: this.$route.query.userId,
        session: this.$route.query.session,
        lang: "en_US",
      };
      objdata.apiUrl = "/getLoginUser";
      var result = await this.$store.dispatch("apiEvent", objdata);
      if (!result) {
        return;
      }
      let assembleFunction = function (parentObj, list) {
        for (var i = 0; i < list.length; i++) {
          var childObj = list[i];
          if (parentObj.id == childObj.parentId) {
            if (parentObj.children) {
              parentObj.children.push(childObj);
            } else {
              parentObj.children = [];
              parentObj.children.push(childObj);
            }
            assembleFunction(childObj, list);
          }
        }
      };
      let systemFuncs = result.data.result.systemFuncs;
      var rootObj = { id: 0 };
      assembleFunction(rootObj, systemFuncs);
      result.data.result.systemFuncs = rootObj.children;
      result.data.result.langCode = "en_US";
      this.$store.state.userInfo = result.data.result;
      this.$store.state.userInfo.loginType = 2;
      sessionStorage.setItem("userInfo", JSON.stringify(result.data.result));
      this.$router.push({ path: "/main/homePage" });
    },
    assembleFunction: function (parentObj, list) {
      for (var i = 0; i < list.length; i++) {
        var childObj = list[i];
        if (parentObj.id == childObj.parentId) {
          if (parentObj.children) {
            parentObj.children.push(childObj);
          } else {
            parentObj.children = [];
            parentObj.children.push(childObj);
          }
          assembleFunction(childObj, list);
        }
      }
    },
  },
  mounted() {
    var self = this;
    if (this.$route.query.userId && this.$route.query.session) {
      setTimeout(function () {
        self.getLoginUser();
      }, 1000);
    } else {
      this.isLogin = true;
    }

    eventBus.$on(
      "warningBtn",
      function (name) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
      }.bind(this)
    );
  },
};
</script>

<style scoped></style>
